<template>
  <div class="record">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="event_type" label="赛事" align="center"></el-table-column>
      <el-table-column prop="apply_grade" label="等级" align="center"></el-table-column>
      <el-table-column prop="apply_time" label="申请时间" align="center" :formatter="dateFormat"></el-table-column>
      <el-table-column prop="apply_status" label="状态" align="center"></el-table-column>
      <el-table-column prop="approval_comments" label="处理意见" align="center"></el-table-column>
    </el-table>
    <div class="pagination" style="margin-top: 40px;text-align:center">
      <el-pagination background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="paging.limit"
          v-if="totalCount>10"
          :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetEventsApplyList } from "@/api/admin/athletes.js";
export default {
  data() {
    return {
      tableData: [],
      totalCount:0,
      paging: {
        limit: 10,
        page: 1
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      GetEventsApplyList(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.tableData = list.items;
          this.totalCount= list.totalCount;
        }
      });
    },
    // 格式化表格时间
    dateFormat(row, column) {
      const date = row[column.property];
      let moment = require("moment");
      if (date != null) {
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    // 分页
    handleCurrentChange(cpage){
        this.paging.page=cpage;
        GetEventsApplyList(Object.assign(this.paging)).then(data => {
            var list = data.data.result;
            if (list) {
                this.tableData= list.items;
            }
        });
    },
  }
};
</script>

<style lang="less" scoped></style>
